import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["children", "hideIcon", "use", "useBreezeStyles"];
import UIButton from 'UIComponents/button/UIButton';
import UIIcon from 'UIComponents/icon/UIIcon';
import { BREEZE_SPECIAL } from '../../../constants/BreezeUse';
import { getStyledCopilotButton } from './styledButtons/StyledCopilotBaseButton';
import styled from 'styled-components';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const StyledUIIcon = styled(UIIcon).withConfig({
  displayName: "CopilotBaseButton__StyledUIIcon",
  componentId: "sc-3chjml-0"
})(["font-size:1.2em;margin-top:-0.1em;"]);
export function CopilotBaseButton(_ref) {
  let {
      children,
      hideIcon = false,
      use = 'tertiary-light',
      // default to tertiary-light
      useBreezeStyles
    } = _ref,
    uiButtonProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const useOverride = use === BREEZE_SPECIAL ? undefined : use;

  /** We want to allow a way for teams to still use non Breeze styling
   * This is a valid design use case where a button grouping the Breeze button will be
   * styled like the other buttons in the group
   */
  if (!useBreezeStyles) {
    return /*#__PURE__*/_jsxs(UIButton, Object.assign({}, uiButtonProps, {
      use: useOverride,
      children: [!hideIcon && /*#__PURE__*/_jsx(StyledUIIcon, {
        name: "breezeSingleStar",
        className: "ai-icon"
      }), children]
    }));
  }
  const CopilotButtonComponent = getStyledCopilotButton(use);
  return /*#__PURE__*/_jsxs(CopilotButtonComponent, Object.assign({}, uiButtonProps, {
    use: useOverride,
    children: [!hideIcon && /*#__PURE__*/_jsx(UIIcon, {
      name: "breezeSingleStar",
      className: "ai-icon"
    }), children]
  }));
}